/**
 * DepthToggle — retired Feb 2026.
 *
 * The platform now renders everything in plain English. The toggle
 * is hidden but the named export is kept so existing imports keep
 * compiling without touching every consumer.
 */
export function DepthToggle() {
  return null;
}

export default DepthToggle;
